<template>
  <div class="tag-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('tag_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-tag</v-icon>{{$t('tag.tags')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <TagFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import TagFilterForm from '../../components/tag/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'TagList',
  servicePrefix: 'Tag',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    TagFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
      ],
  selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('tag', {
      items: 'list'
    }),
    ...mapFields('tag', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('tag', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
